import { render, staticRenderFns } from "./myInfo.vue?vue&type=template&id=455dac1d&scoped=true"
import script from "./myInfo.vue?vue&type=script&lang=js"
export * from "./myInfo.vue?vue&type=script&lang=js"
import style0 from "./myInfo.vue?vue&type=style&index=0&id=455dac1d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455dac1d",
  null
  
)

export default component.exports